<form *ngIf="order" name="contact-us">
  <h2 mat-dialog-title>Contact Us About This Order</h2>
  <mat-dialog-content class="fx-layout-column">
    <mat-form-field *ngIf="order.Status === 'SHIPPED' || order.Status === 'DELIVERED'">
      <mat-label>reason</mat-label>
      <mat-select [(ngModel)]="contact.reason" name="reason" required="required">
          <mat-option value="DAMAGED">Damaged in Shipping</mat-option>
          <mat-option value="SIZE">Incorrect Size</mat-option>
          <mat-option value="COLOR">Incorrect Color</mat-option>
          <mat-option value="OTHER">Other</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>comments</mat-label>
      <textarea name="comments"
                matInput
                [(ngModel)]="contact.comments"
                required="required"></textarea>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button (click)="sendMessage()" class="full-width" mat-flat-button color="primary">Send Message</button>
  </mat-dialog-actions>
</form>
